import { ArtData } from '@/database/art'
import { ArtState } from '@/database/types'

export const listing = (artData: ArtData) => {
    switch (artData.art.state) {
        case ArtState.AUCTION:
            return 'On Auction'
        case ArtState.FORCED_AUCTION:
            return 'On Forced Auction'
        case ArtState.FOR_SALE:
            return 'For Sale'
        case ArtState.HIDDEN:
            return 'Hidden'
        case ArtState.NOT_FOR_SALE:
            return 'Not for sale'
        case ArtState.CREATED:
            return 'Available as Art (Not minted as NFT)'
        case ArtState.BLOCKED:
            return 'Blocked'
    }
}
